import React, { useState } from "react"
import { AttachFile, PictureAsPdf } from '@material-ui/icons';
import ModalLayout from "../ModalLayout";
import { Paragraph, StyledDropzone } from "./styles";
import { toast } from "react-toastify";

const ChooseFile = ({ title, confirmAction, closeModalAction, dropzoneDescription, dropzoneText, files, filesLimit = 1 }) => {
    const [localFiles, setLocalFiles] = useState(files || []);
    const limit = 3000000;

    const handlePreviewIcon = (fileObject) => {
        if (!fileObject) return null;

        if (fileObject.file.type && fileObject.file.type.startsWith('image/')) {
            return (
                <img
                    className="MuiDropzonePreviewList-image"
                    src={URL.createObjectURL(fileObject.file)}
                    alt="preview"
                />
            );
        } else if (fileObject.file.type === 'application/pdf') {
            return (
                <PictureAsPdf className="MuiDropzonePreviewList-image" />
            );
        } else {
            return (
                <AttachFile className="MuiDropzonePreviewList-image" />
            );
        }
    }

    const handleOnAlert = (message, variant) => {
        if (variant === "error") {
            toast.error(message);
        }
    };

    return (
        <ModalLayout
            showModal={true}
            handleCloseModal={closeModalAction}
            title={title}
            buttonLeft={{
                text: "Confirmar",
                action: () => { confirmAction(localFiles); },
                disabled: localFiles.length === 0,
            }}
            buttonRight={{
                text: "Voltar",
                action: closeModalAction
            }}
        >
            <Paragraph>
                {dropzoneDescription}
            </Paragraph>
            <StyledDropzone
                initialFiles={localFiles}
                onChange={(files) => setLocalFiles(files)}
                filesLimit={filesLimit}
                maxFileSize={limit}
                getFileLimitExceedMessage={(filesLimit) => `Você pode enviar apenas ${filesLimit} arquivo(s)`}
                Icon={AttachFile}
                acceptedFiles={[".pdf", ".jpg", ".jpeg", ".png"]}
                getDropRejectMessage={(file, acceptedFiles, maxFileSize) => {
                    const extension = `.${file.name.split(".").pop()}`;
                    if (!acceptedFiles.includes(extension)) {
                        return `Tipo de arquivo inválido. Os tipos de arquivos aceitos: ${acceptedFiles.join(", ")}.`;
                    }
                    if (maxFileSize > 0 && file.size > maxFileSize) {
                        return `Arquivo ultrapassa o limite de ${limit / 1000000}MB`;
                    }
                    return "";
                }}
                dropzoneText={`${dropzoneText} (Formatos aceitos: pdf, jpg, jpeg, png)`}
                showFileNames={true}
                showFileNamesInPreview={true}
                showAlerts={false}
                getPreviewIcon={handlePreviewIcon}
                onAlert={handleOnAlert}
            />

        </ModalLayout>
    )
}

export default ChooseFile